import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.4rem",
    color: "#fff",
    cursor: "pointer",
  },
  playIcon: {
    width: 0,
    height: 0,
    "border-style": "solid",
    "border-width": "9px 0 9px 12px",
    "border-color": "transparent transparent transparent #fff",
    marginRight: 4,
  },
  stopIcon: {
    width: 16,
    height: 16,
    backgroundColor: "#fff",
    marginRight: 4,
  },
});

function PlayButton(props) {
  const { label, isPlaying, onClick, width = 200, disableIcon = false } = props;
  const classes = useStyles();

  if (!disableIcon) {
    if (isPlaying) {
      return (
        <div
          className={classes.root}
          style={{ flexBasis: width }}
          onClick={onClick}
        >
          <div className={classes.stopIcon}></div>
          ていし
        </div>
      );
    } else {
      return (
        <div
          className={classes.root}
          style={{ flexBasis: width }}
          onClick={onClick}
        >
          <div className={classes.playIcon}></div>
          {label}
        </div>
      );
    }
  } else {
    return (
      <div
        className={classes.root}
        style={{ flexBasis: width }}
        onClick={onClick}
      >
        {label}
      </div>
    );
  }
}

export default PlayButton;
